import React, { useEffect, useRef, useState } from "react";
import Label from "./Label";
import ErrorMessage from "./ErrorMessage";
import ChipList from "../BuilderComponents/ChipList";

function ChipsInput({
  inputArray,
  onChange,
  label = "",
  containerClassName = "",
  chipClassName = "",
  placeholder = "Press Enter to add tag",
  maxLength = 20,
  minLength = 1,
  maxChips = Infinity,
  validateChipCustom
}) {
  const [text, setText] = useState("");
  const [chips, setChips] = useState(() => initializeChips(inputArray));
  const [validationError, setValidationError] = useState("");
  const [noHandleChangeError, setNoHandleChangeError] = useState(false);
  const inputRef = useRef(null);

  function initializeChips(inputArray) {
    if (!Array.isArray(inputArray)) return [];
    return inputArray;
  }

  const validateChip = (chip) => {
    const trimmed = chip.trim();

    if (trimmed === "") return "Input cannot be empty";
    if (trimmed.length < minLength) return `Minimum length is ${minLength}`;
    if (trimmed.length > maxLength) return `Input cannot exceed ${maxLength} characters`;
    if (chips.includes(trimmed)) return "Cannot add the same input more than once";
    if (chips.length >= maxChips) return `You can only add up to ${maxChips} chips`;

    if (validateChipCustom) {
      const customError = validateChipCustom(trimmed);
      if (customError) return customError;
    }

    return "";
  };

  const removeChip = (chipToRemove) => {
    setChips(chips.filter((chip) => chip !== chipToRemove));
  };

  const handleKeyDown = (e) => {
    const trimmed = text.trim();

    if (e.key === "Enter") {
      e.preventDefault();
      if (!trimmed) return;

      const error = validateChip(trimmed);
      if (error) {
        setValidationError(error);
        return;
      }

      setChips([...chips, trimmed]);
      setText("");
      setValidationError("");
    }
  };

  useEffect(() => {
    if (onChange) {
      onChange(chips);
      setNoHandleChangeError(false);
    } else {
      setNoHandleChangeError(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chips]);

  return (
    <div className="form_element_wrapper_text" style={{ width: "100%" }}>
      {label && <Label>{label}</Label>}
      <div
        className={`builder_input chips_input_container ${containerClassName}`}
        onClick={() => inputRef.current.focus()}
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "6px",
          padding: "8px",
          borderRadius: "4px",
          cursor: "text"
        }}
      >
        <ChipList chips={chips} removeChip={removeChip} chipClassName={chipClassName} />

        {chips.length < maxChips && (
          <input
            ref={inputRef}
            type="text"
            id="tags"
            placeholder={placeholder}
            value={text}
            onChange={(e) => {
              setText(e.target.value);
              setValidationError("");
            }}
            onKeyDown={handleKeyDown}
            style={{
              flex: "1 1 auto",
              border: "none",
              outline: "none",
              minWidth: "120px",
              padding: "4px 0"
            }}
            d
          />
        )}
      </div>
      {validationError && <ErrorMessage>{validationError}</ErrorMessage>}
      {noHandleChangeError && <ErrorMessage>handleChange operation required</ErrorMessage>}
    </div>
  );
}

export default ChipsInput;
